import React, {Component} from "react"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import {Row, Col} from "react-bootstrap"

import {H2, Label} from "@irati/ui/src/Typography"
import Form from "@irati/ui/src/Form"
import Flex from "@irati/ui/src/Flex"
import Description from "@irati-web/fields/companyBenefits/Description"
import ContactInformation from "@irati-web/fields/companyBenefits/ContactInformation"
import ImportantInformation from "@irati-web/fields/companyBenefits/ImportantInformation"
import {Deal} from "@irati/types"
import adminTracking from "@irati-tracking/admin"

import {CARD, INSTRUCTIONS} from "./Popup"
import H4, {FormSectionHeading} from "./styled/H4"
import Div from "./styled/Div"
import {StyledValidationButton, StyledIconButton} from "./styled/Button"

interface Props extends InjectIntl {
  show: boolean
  benefit: Deal
  onChange: (property: string, value: string) => void
  selectStep: (step: string) => void
}

class DescriptionStep extends Component<Props> {
  handleContinue = () => {
    adminTracking.companyBenefitsAddDescription()
    this.props.selectStep(INSTRUCTIONS)
  }

  render() {
    const {show, benefit, onChange, selectStep, formatMessage} = this.props

    if (!show) {
      return null
    }

    return (
      <>
        <StyledIconButton
          onClick={() => {
            selectStep(CARD)
          }}
          icon="backArrow"
        />
        <Div>
          <Flex direction="column" alignItems="center">
            <Label uppercase>
              <FormattedMessage id="admin.components.companyBenefits.description.stepTwo" />
            </Label>
            <H2>
              <FormattedMessage id="admin.components.companyBenefits.description.headerTwo.companyBenefit" />
            </H2>
            <H2>
              <FormattedMessage id="admin.components.companyBenefits.description.headerTwo.description" />
            </H2>
            <H4>
              <FormattedMessage id="admin.components.companyBenefits.description.headerTwo.addInformation" />
            </H4>
          </Flex>
          <Row>
            <Col md={12}>
              <Form form="create-company-benefit-step2">
                <Col md={12}>
                  <Description benefit={benefit} onChange={onChange} />
                  <ContactInformation benefit={benefit} onChange={onChange} />
                  <FormSectionHeading>
                    <FormattedMessage id="admin.components.companyBenefits.description.formSectionHeading.text" />
                  </FormSectionHeading>
                  <ImportantInformation benefit={benefit} onChange={onChange} />
                </Col>
              </Form>
            </Col>
          </Row>
          <Flex justifyContent="center">
            <StyledValidationButton
              primary
              large
              loading={formatMessage({id: "admin.components.companyBenefits.description.validationButton.loading"})}
              onClick={this.handleContinue}>
              <FormattedMessage id="admin.components.companyBenefits.description.validationButton.continue" />
            </StyledValidationButton>
          </Flex>
        </Div>
      </>
    )
  }
}

export default injectIntl(DescriptionStep)
